export default {
    Analytics: {
        Feedback: {
            labels: {
                okButton: "OkButton",
            },
        },
    },
};



// WEBPACK FOOTER //
// ./settings/analytics.ts